import { AfterViewInit, Component, HostBinding, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ControlState } from '../api/model/models';
import { CfControlService } from './cf-control.service';

@Component({
  selector: 'cf-frontend-sdk-control',
  templateUrl: './cf-control.component.html',
})
export class CfControlComponent implements OnInit, AfterViewInit {
  /**
   * The control state containing all the data necessary for initializing a control.
   * @param val control state.
   */
  @Input()
  public set controlState(val: ControlState | undefined) {
    this._controlState = val;
    this.render(this._controlState);
  }
  public get controlState() {
    return this._controlState;
  }
  private _controlState: ControlState | undefined;

  /**
   * The control's host element.
   */
  @ViewChild('cmpHost', { read: ViewContainerRef, static: true })
  public cmpHost!: ViewContainerRef;

  /**
   * UID of the entity. Required for loading the control on the fly.
   */
  @Input() public uid?: string;

  /**
   * Feature name belonging to the entity. Required for loading the control on the fly.
   */
  @Input() public feature?: string;

  /**
   * Whether the control is registered to be loaded.
   */
  @HostBinding('attr.registered-for-loading')
  public registeredForLoading = false;

  constructor(private cfControlService: CfControlService) {}

  public ngOnInit() {
    this.registeredForLoading = !!(this.uid && this.feature);
  }

  public ngAfterViewInit(): void {
    if (this.uid && this.feature) {
      this.cfControlService.registerForLoading(this, this.uid, this.feature);
    }
  }

  /**
   * Clears and re-renders the component
   * @param controlState Control state data
   * @private
   */
  private render(controlState: ControlState | undefined): void {
    this.cmpHost.clear();
    if (controlState) {
      this.cfControlService.render(controlState, this.cmpHost);
    }
  }
}
